// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBct_1-LOssqb_lBHYLI9432gUDRvkGThM',
  authDomain: 'pronosticker-e71c3.firebaseapp.com',
  projectId: 'pronosticker-e71c3',
  storageBucket: 'pronosticker-e71c3.appspot.com',
  messagingSenderId: '675111016313',
  appId: '1:675111016313:web:652a80aa8bbc70fcbf41a8',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
